import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Link from '../../components/link/link';

import styles from './venue-event-list.module.scss';

const normalize = (str) => typeof str === 'string' ? str.trim().toLowerCase() : '';

const today = moment();

 const SERIES_VENUE_TITLES = ['sundown social', 'sandy springs farmers market'];

const isFutureOrOngoing = (start, end) => {
  
  const startDate = start ? moment(start) : null;
  const endDate = end ? moment(end) : null;

  if (endDate) {
    return endDate.isSameOrAfter(today, 'day');
  } 
  if (startDate) {
    return startDate.isSameOrAfter(today, 'day');
  } 
  return false;
};

 const getSeriesFromVenue = (title = '') => {
  const sanitizedTitle = typeof title === 'string' ? title.trim().toLowerCase() : '';
  return SERIES_VENUE_TITLES.find((item) => sanitizedTitle === item) || '';
};

const VenueEventList = ({ events = [], venue }) => {
 
  const series = getSeriesFromVenue(venue);
  const normalizedVenue = normalize(venue);
  const normalizedSeries = normalize(series);
  const matchedSeries = SERIES_VENUE_TITLES.includes(normalizedSeries) ? normalizedSeries : '';

  const filteredEvents = events.filter((event) => {
    const eventSeries = normalize(event.relationships?.field_series?.name);
    const eventVenue = normalize(event.relationships?.field_venue?.title);
    const start = event.date?.start;
    const end = event.date?.end;

    if (!start) return false;

    const isMatchingSeries = matchedSeries && eventSeries === matchedSeries;
    const isMatchingVenue = !matchedSeries && eventVenue === normalizedVenue;

    return isFutureOrOngoing(start, end) && (isMatchingSeries || isMatchingVenue);
  });

  if (filteredEvents.length === 0) return null;

  return (
    <div className={styles.eventListContainer}>
      <h2>Upcoming {series === 'sandy springs farmers market' ? `Markets` : `Events`}{!series && venue && ` at ${venue}`}</h2>
      {filteredEvents.slice(0,8).map((event) => {
        const { title, date, path, field_image, relationships, body } = event;
        const startDate = date?.start;
        const endDate = date?.end;
        const sameDay = startDate === endDate;

        const formattedStart = moment(startDate).format('MMMM D, YYYY');
        const formattedEnd = moment(endDate).format('MMMM D, YYYY');

        const imageSrc =
          field_image?.imageDerivatives?.links?.max_1600_16_9?.href ||
          relationships?.field_image?.max_1600_16_9?.childImageSharp?.contentTeaser?.src ||
          '/images/site-default-image.png';

        return (
          <Link
            key={title}
            to={path.alias}
            aria-label={`View details about the event: ${title}`}
            className={styles.eventLink}
          >
            <div className={styles.eventWrapper}>
              <img
                src={imageSrc}
                alt={title || 'Event image'}
                loading="lazy"
              />
              <div className={styles.contentWrapper}>
                <h3>{title}</h3>
                <p aria-label={`Event date${sameDay ? '' : 's'}`}>
                  {sameDay ? formattedStart : `${formattedStart} - ${formattedEnd}`}
                </p>
                {series && (
                  <p aria-label="summary" className={styles.eventSummary}>
                    {body?.summary}
                  </p>
                )}
              </div>
            </div>
          </Link>
        );
      })}
    </div>
  );
};

VenueEventList.propTypes = {
  events: PropTypes.array,
  venue: PropTypes.string,
};

export default VenueEventList;
